import { useCurrency } from '@/context/CurrencyContext';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

const CurrencySelector = ({ className = '' }) => {
  const { currency, setCurrency, availableCurrencies } = useCurrency();

  return (
    <Select value={currency} onValueChange={setCurrency}>
      <SelectTrigger className={`w-28 bg-transparent border-white/20 text-sm ${className}`} data-testid="currency-selector">
        <SelectValue />
      </SelectTrigger>
      <SelectContent className="bg-obsidian border-white/20 text-white max-h-64">
        {availableCurrencies.map((c) => (
          <SelectItem key={c.code} value={c.code} className="hover:bg-white/10">
            <span className="flex items-center gap-2">
              <span className="font-mono text-gold">{c.symbol}</span>
              <span>{c.code}</span>
            </span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default CurrencySelector;
